var _CacheManager_config;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate } from "tslib";
import { CacheManager as CachingBrowser, CacheType, IndexedDB, } from '@descomplica/caching-browser';
import { singleton } from 'tsyringe';
let CacheManager = class CacheManager {
    constructor() {
        _CacheManager_config.set(this, void 0);
    }
    init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _CacheManager_config, config, "f");
            this.memory = CachingBrowser.getCache(CacheType.MEMORY, __classPrivateFieldGet(this, _CacheManager_config, "f").caching.namespace);
            this.localStorage = CachingBrowser.getCache(CacheType.LOCALSTORAGE, __classPrivateFieldGet(this, _CacheManager_config, "f").caching.namespace);
            try {
                yield IndexedDB.setup(__classPrivateFieldGet(this, _CacheManager_config, "f").caching.namespace);
                this.indexedDb = CachingBrowser.getCache(CacheType.INDEXEDDB, __classPrivateFieldGet(this, _CacheManager_config, "f").caching.namespace);
            }
            catch (error) {
                console.warn('Unable to start IndexedDB');
            }
        });
    }
};
_CacheManager_config = new WeakMap();
CacheManager = __decorate([
    singleton()
], CacheManager);
export { CacheManager };
